var React = require('react');

function CheckmarkInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"submit"),React.createElement("polyline",{"points":"416 128 192 384 96 288","style":{"fill":"none","stroke":"#FFFFFF","strokeLinecap":"square","strokeLinejoin":"miter","strokeWidth":"32px"},"key":1})]);
}

CheckmarkInline.defaultProps = {"width":"40","height":"40","viewBox":"0 0 512 512"};

module.exports = CheckmarkInline;

CheckmarkInline.default = CheckmarkInline;
